import {useQuery} from "react-query";

import {FacilityService} from "../../../services/FacilityService";
import {SimpleFacilityModel} from "../../../utils/types/facility";

export const ReportingFacilitiesQueryName = "ReportingFacilities";

/**
 * Facilities reporting uses: the active ones, and the inactive ones a Reside admin kept in reporting.
 * Fetched separately from the session facilities, which only hold the active facilities for everyone but Reside admins.
 */
export const useReportingFacilitiesQuery = () =>
  useQuery(
    ReportingFacilitiesQueryName,
    async (): Promise<ReadonlyArray<SimpleFacilityModel>> => {
      const {data} = await FacilityService.getAll({forReporting: true});
      return data?.content ?? [];
    },
    {refetchOnWindowFocus: false},
  );
